/* ============================================================
   Nordstealth Premium-Ebene: Scroll-Reveal — ERSATZLOESUNG
   Sektionen steigen beim Reinscrollen weich auf.
   - IntersectionObserver (kein Scroll-Listener, kein Layout-Thrash)
   - ueberspringt Kauf-Sektion (sticky ATC bleibt heil), Header/Footer
     und Divider-Sektionen
   - versteckt nichts, was beim Laden schon sichtbar ist -> kein Aufblitzen
   - respektiert prefers-reduced-motion

   WICHTIG — Vorrang der Theme-Animation:
   Shrine bringt eine eigene Einblendung mit (Einstellung
   enable_load_animations, Markup ".animate-section animate--hidden",
   Beobachter und CSS in layout/theme.liquid). Sie ist feiner: sie
   animiert einzelne .animate-item statt ganzer Sektionen, hat einen
   einstellbaren Kind-Versatz und legt keinen transform ueber die
   komplette Sektion. Deshalb gewinnt sie. Diese Ebene laeuft nur, wenn
   der Haendler die Theme-Animation abgeschaltet hat — sonst blendet
   jede Sektion zweimal ein.

   Erkennung: layout/theme.liquid gibt --animation-duration auf
   .animate-section nur aus, wenn enable_load_animations gesetzt ist.
   Die Klassen allein stehen unabhaengig davon im Markup und taugen
   nicht als Signal.
   ============================================================ */
(function () {
  // Reduced-motion: gar nicht erst anschalten, dann bleibt alles sichtbar.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function themeRevealAktiv() {
    var probe = document.querySelector('.animate-section');
    if (!probe) return false;
    var dauer = getComputedStyle(probe).getPropertyValue('--animation-duration');
    return !!(dauer && dauer.trim());
  }
  if (themeRevealAktiv()) return;

  document.documentElement.classList.add('ns-reveal-on');

  // Nach der Einblendung alle Reveal-Styles wieder abraeumen. Sonst bleiben
  // transition und (bis .ns-in greift) will-change auf der Sektion stehen.
  // Wartezeit = Sektionsdauer .7s + Puffer + laengster Kind-Versatz.
  function aufraeumen(sec) {
    var kinder = sec.querySelectorAll('[data-ns-stagger]').length;
    window.setTimeout(function () {
      sec.removeAttribute('data-ns-reveal');
    }, 900 + kinder * 70);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ns-in');
          io.unobserve(e.target);
          aufraeumen(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
  );

  function eligible(sec) {
    // Kauf-Sektion nicht transformieren: ein transform-Elternteil bricht
    // position: sticky in der Buy-Box.
    if (sec.querySelector('.product__info-container, product-form, .product-form')) return false;
    // Header und Footer bleiben immer sofort da.
    if (sec.closest('.header-wrapper, .shopify-section-group-header-group, .shopify-section-group-footer-group, footer, .footer')) return false;
    if (sec.classList.contains('section-header')) return false;
    // Divider gehoeren optisch zur Nachbar-Sektion und blenden nie eigenstaendig ein.
    if (sec.querySelector('.section-divider')) return false;
    return true;
  }

  function init() {
    var vh = window.innerHeight || 800;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), function (sec) {
      if (!eligible(sec)) return;
      // Beim Laden schon (fast) im Viewport: nicht verstecken -> kein Aufblitzen.
      if (sec.getBoundingClientRect().top < vh * 0.85) return;

      sec.setAttribute('data-ns-reveal', '');

      // Stagger-Index setzen, falls die Sektion Kinder markiert hat.
      var kinder = sec.querySelectorAll('[data-ns-stagger]');
      for (var i = 0; i < kinder.length; i++) {
        if (!kinder[i].style.getPropertyValue('--ns-i')) {
          kinder[i].style.setProperty('--ns-i', String(i));
        }
      }

      io.observe(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Dauerlaeufer nur im Bild laufen lassen.

   ns-premium.css haelt jede Endlosschleife per animation-play-state
   an. Dieser Block gibt sie frei, solange ihr Traeger sichtbar ist,
   und haelt sie wieder an, wenn er das Bild verlaesst.

   Warum ueberhaupt: gemessen liefen auf der Produktseite 23
   Endlos-Animationen dauerhaft, davon 20 in den fuenf Wellen-Trennern
   (base.css .parallax1..4 > use). SVG-Transformationen gehen in Chrome
   nicht auf den Compositor, jedes Bild ist also ein echtes Neuzeichnen —
   auch fuer einen Trenner, der drei Bildschirme weiter unten steht.

   Der Block laeuft unabhaengig vom Reveal oben: dort gibt es fruehe
   return-Zweige (Theme-Animation aktiv), die hier nichts zu suchen
   haben. Bei reduzierter Bewegung passiert nichts — dann sind die
   Animationen per CSS ohnehin ganz aus.
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) {
    // Ohne Beobachter lieber laufen lassen als dauerhaft still stehen.
    document.documentElement.classList.add('ns-loop-an');
    return;
  }

  // Traeger der Endlosschleifen. Die Wellen sitzen als <use> tief im SVG,
  // beobachtet wird deshalb der Trenner; die Glanz-Sweeps sind ::after
  // ihres eigenen Abzeichens und tragen die Klasse selbst.
  // Seit dem 02.09.2026 haengen auch die laufenden Raender hier drin
  // (Abschnitt LAUFENDER RAND in ns-premium.css). Dadurch gilt fuer sie
  // automatisch dasselbe wie fuer alle Dauerlaeufer: Lauf nur im Bild, und
  // bei reduzierter Bewegung gar nicht.
  // KEIN :has() und nichts Exotisches in dieser Liste — sie geht ungeschuetzt
  // an querySelectorAll, ein ungueltiger Selektor legt ALLE Dauerlaeufer lahm.
  var SEL = '.section-divider, .price__badge-sale, .price__badge-custom, .quantity-break__badge, .ns-daily'
    + ', .ns-kern__frame, .ns-an__media, .ns-mat__media'
    + ', [id*="image_with_text_cDpRmP"] .image-with-text__media'
    + ', [id*="image_with_text_WTirrn"] .image-with-text__media';

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('ns-loop-an', e.isIntersecting);
      });
    },
    // Etwas Vorlauf, damit der Sweep nicht erst mitten im Blick anspringt.
    { rootMargin: '120px 0px 120px 0px', threshold: 0 }
  );

  function beobachten(wurzel) {
    Array.prototype.forEach.call((wurzel || document).querySelectorAll(SEL), function (el) {
      if (el.dataset.nsLoop) return;
      el.dataset.nsLoop = '1';
      io.observe(el);
    });
  }

  function start() {
    beobachten(document);
    // Bundle-Abzeichen und Tagesbotschaft werden von Shrine teils erst
    // nach einem Variantenwechsel neu gezeichnet. Ein flacher Beobachter
    // auf der Kauf-Sektion holt sie nach, ohne dauernd zu pollen.
    if ('MutationObserver' in window) {
      var kauf = document.querySelector('.product__info-container') || document.body;
      new MutationObserver(function () { beobachten(kauf); }).observe(kauf, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   BILDER OHNE ALT-ATTRIBUT
   ------------------------------------------------------------
   Im Theme sind alle Stellen versorgt (Galerie, Produktkarten,
   Bild-mit-Text, Schubladenlogo). Was aus dem Adminbereich kommt —
   Bilder in Seitentexten, Bilder aus Apps — laesst sich dort nicht
   erreichen. Ein Vorleseprogramm liest dann den Dateinamen vor
   ("8484logo.webp").

   Solche Bilder bekommen hier ein LEERES alt. Das ist die richtige
   Auszeichnung fuer schmueckendes Beiwerk: der Vorleser ueberspringt
   sie, statt Unsinn vorzulesen. Bilder MIT alt bleiben unberuehrt.
   ============================================================ */
(function () {
  function fuellen() {
    var bilder = document.querySelectorAll('img:not([alt])');
    for (var i = 0; i < bilder.length; i++) bilder[i].setAttribute('alt', '');
  }

  function start() {
    fuellen();
    if (!('MutationObserver' in window)) return;
    var wartet = 0;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = setTimeout(function () { wartet = 0; fuellen(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   KEIN EINZELNES WORT AUF DER LETZTEN ZEILE EINER UEBERSCHRIFT
   ------------------------------------------------------------
   Eine Ueberschrift, deren letzte Zeile aus einem Wort besteht, sieht
   nach Fehler aus. CSS allein reicht dafuer nicht: text-wrap: balance
   verteilt die Zeilen gleichmaessig, verhindert das einzelne Wort aber
   nicht zuverlaessig, und text-wrap: pretty kennen bis heute nicht alle
   Browser.

   Hier wird deshalb GEMESSEN statt geraten:
     1. Ueber den gesamten Inhalt der Ueberschrift wird ein Range gelegt.
        getClientRects() liefert dann ein Rechteck je Zeile.
     2. Ein zweiter Range umfasst nur das letzte Wort. Beginnt es an
        derselben Stelle, an der die letzte Zeile beginnt, steht es
        allein dort.
     3. Dann wird das Leerzeichen davor durch ein geschuetztes ersetzt.
        Damit rutscht das vorletzte Wort mit nach unten.
     4. Gegenprobe: laeuft die Ueberschrift dadurch aus ihrem Kasten
        (sehr lange Woerter), wird die Aenderung zurueckgenommen.

   Laeuft nach dem Laden, nach dem Laden der Schriften und bei jeder
   Groessenaenderung erneut, weil sich der Umbruch dabei aendert.
   ============================================================ */
(function () {
  // Seit 29.08.2026 nicht mehr nur Ueberschriften. Gemessen wurden einzelne
  // Woerter auf der letzten Zeile vor allem dort, wo kurzer Text in einem
  // schmalen Kasten steht: Kacheln, Siegel, Knoepfe, Vergleichstabelle,
  // Vertrauenszeile. text-wrap: balance und pretty helfen, reichen aber
  // nicht ueberall — dieses Skript misst nach und bindet das letzte
  // Wortpaar, und nimmt es zurueck, sobald es schadet.
  var SEL = [
    'h1', 'h2', 'h3', 'h4',
    '.ns-hero__title', '.ns-kern__title', '.ns-ma__title', '.ns-cta__title',
    '.ns-vg__title', '.ns-mat__title', '.ns-an__title', '.ns-sz__title',
    '.ns-testi-headline', '.ns-review-headline', '.ns-proof__ttl',
    '.card__heading a', '.accordion__title', '.ns-cart__title',
    // kurze Beschriftungen
    '.ns-hero__pill', '.ns-daily__tx',
    '.ns-usp__t', '.ns-usp__s',
    '.ns-trust-title', '.ns-trust-desc',
    '.ns-siegel__t', '.ns-siegel__s',
    '.ns-vg__c--label', '.ns-vg__lang',
    '.ns-mat__chip-val', '.ns-mat__chip-lab', '.ns-mat__tag',
    '.ns-an__trigger', '.ns-an__note',
    '.ns-sz__t', '.ns-kern__t',
    '.ns-agg__basis', '.ns-verified',
    '.ns-rt__ablauf-s', '.ns-sv__hinweis-t',
    '.ns-cta__btn', '.ns-kern__btn',
    '.quantity-break__label-text', '.quantity-break__caption',
    '.button__label', '.main-atc__label__text',
    '.ns-ci__name', '.ns-ladder__txt',
    '.ns-review-text', '.ns-proof__t',
    // Nachtrag 29.08.2026, aus der zweiten Messung: Aufzaehlungen in den
    // Vertrauensleisten (CTA-Band und Warenkorb-Zusammenfassung), die
    // Fliesstexte der Machart-Karten, Produktkarten im Katalog und die
    // Rechtstexte. Ueberall dort stand ein einzelnes Wort auf der letzten
    // Zeile, das text-wrap: pretty nicht wegbekommen hat.
    '.ns-cta__trust li', '.ns-cta__trust span', '.ns-cta__note',
    '.ns-tr li', '.ns-tr span',
    '.ns-ma__t',
    '.quick-add__submit', '.full-unstyled-link',
    '.rte p', '.shopify-policy__body p',
  ].join(',');

  var NBSP = '\u00A0';
  var VERBINDER = '\u2060'; // WORD JOINER: verbietet den Umbruch, zeigt nichts an

  function letztesWortAllein(el) {
    var bereich = document.createRange();
    bereich.selectNodeContents(el);
    var zeilen = bereich.getClientRects();
    if (zeilen.length < 2) return false;
    var letzte = zeilen[zeilen.length - 1];

    // Letzten Textknoten mit Inhalt suchen.
    var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var knoten = null;
    var n;
    while ((n = lauf.nextNode())) { if (n.nodeValue.trim()) knoten = n; }
    if (!knoten) return false;

    var text = knoten.nodeValue;
    var ende = text.replace(/\s+$/, '').length;
    // Nicht nur am Leerzeichen: "Nordstealth Body-Sling" brach bei 768px am
    // Bindestrich und liess "Sling" allein stehen. Die Stelle davor ist dann
    // der Bindestrich, nicht das Leerzeichen.
    var start = Math.max(text.lastIndexOf(' ', ende - 1), text.lastIndexOf('-', ende - 1));
    if (start < 0) return false;

    var wort = document.createRange();
    wort.setStart(knoten, start + 1);
    wort.setEnd(knoten, ende);
    var wr = wort.getBoundingClientRect();
    if (!wr.width) return false;

    // Gleiche Zeile wie die letzte Zeile und gleicher Zeilenanfang?
    var gleicheZeile = Math.abs(wr.top - letzte.top) < 3;
    var beginntZeile = Math.abs(wr.left - letzte.left) < 3;
    return gleicheZeile && beginntZeile;
  }

  // Steht das gebundene Wortpaar auf EINER Zeile?
  //
  // Warum das noetig ist (gefunden am 29.08.2026 im Impressum bei 320px):
  // Das Skript band "Verbraucherschlichtungsstelle" und "teilzunehmen." zu
  // einem Block von rund 335px in einer 288px breiten Spalte. Der Block
  // passte in keine Zeile, und overflow-wrap: break-word riss ihn mitten im
  // Wort auseinander — "…teilzun / ehmen.". Aus einem einzelnen Wort auf der
  // letzten Zeile wurde so ein gerissenes Wort, also das Schlimmere.
  //
  // Die alte Gegenprobe sah das nicht: der Text war ja umgebrochen und lief
  // nicht aus dem Kasten. Ein gebundenes Paar, das passt, hat GENAU EIN
  // Rechteck. Zwei heissen: zerrissen, Bindung zurueck.
  function paarRechtecke(el) {
    var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var knoten = null;
    var n;
    while ((n = lauf.nextNode())) { if (n.nodeValue.trim()) knoten = n; }
    if (!knoten) return 0;
    var text = knoten.nodeValue;
    var ende = text.replace(/\s+$/, '').length;
    var start = Math.max(text.lastIndexOf(' ', ende - 1), text.lastIndexOf('-', ende - 1));
    if (start < 0) return 1;
    // Nach dem Binden steht zwischen den beiden Woertern ein geschuetztes
    // Leerzeichen. lastIndexOf(' ') findet es NICHT und liefert deshalb die
    // Stelle DAVOR — genau den Anfang des gebundenen Paares.
    // Traegt das Paar weiche Trennstriche, DARF es ueber zwei Zeilen laufen:
    // der Browser trennt dann sauber mit Strich und genau dafuer stehen sie
    // da. Gemessen am 29.08.2026 im Impressum bei 320px — gebunden ergibt
    // das "Verbraucher-", "schlichtungs-", "stelle teilzunehmen.", also drei
    // Zeilen ohne einzelnes Wort am Ende. Ohne Trennstriche bedeuten zwei
    // Rechtecke dagegen ein mitten durchgerissenes Wort.
    if (text.slice(start + 1, ende).indexOf('\u00AD') >= 0) return 1;
    var r = document.createRange();
    r.setStart(knoten, start + 1);
    r.setEnd(knoten, ende);
    return r.getClientRects().length;
  }

  function binden(el) {
    var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var knoten = null;
    var n;
    while ((n = lauf.nextNode())) { if (n.nodeValue.trim()) knoten = n; }
    if (!knoten) return false;
    var text = knoten.nodeValue;
    var ende = text.replace(/\s+$/, '').length;
    var start = Math.max(text.lastIndexOf(' ', ende - 1), text.lastIndexOf('-', ende - 1));
    if (start < 0) return false;
    // Am Leerzeichen wird gebunden, indem es durch ein geschuetztes ersetzt
    // wird. Am Bindestrich darf er nicht verschwinden — dort kommt ein
    // Wortverbinder (U+2060) dahinter, der den Umbruch an dieser Stelle
    // verbietet, ohne etwas anzuzeigen.
    if (text[start] === '-') knoten.nodeValue = text.slice(0, start + 1) + VERBINDER + text.slice(start + 1);
    else knoten.nodeValue = text.slice(0, start) + NBSP + text.slice(start + 1);
    return true;
  }

  function loesen(el) {
    var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = lauf.nextNode())) {
      if (n.nodeValue.indexOf(NBSP) >= 0) n.nodeValue = n.nodeValue.replace(NBSP, ' ');
      if (n.nodeValue.indexOf(VERBINDER) >= 0) n.nodeValue = n.nodeValue.split(VERBINDER).join('');
    }
    return;
  }

  function pruefe(el) {
    if (!el || el.closest('.menu-drawer, .header, .facets')) return;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;

    // Frueher gesetzte Bindung erst loesen, sonst summieren sie sich
    // ueber mehrere Durchgaenge.
    loesen(el);
    if (!letztesWortAllein(el)) return;



    var hoeheVorher = el.getBoundingClientRect().height;
    if (!binden(el)) return;

    // Gegenprobe. Zurueckgenommen wird nur, wenn die Bindung wirklich
    // schadet: wenn die Ueberschrift dadurch hoeher wird (eine Zeile mehr)
    // oder ein Wort seitlich aus dem Kasten laeuft.
    //
    // Die Schwelle liegt bei 2px, nicht bei 1: Browser runden die
    // Textbreite, und bei text-wrap: balance lag scrollWidth regelmaessig
    // ein Pixel ueber clientWidth. Mit der engeren Schwelle wurde JEDE
    // Bindung sofort wieder geloest, und die Ueberschriften blieben
    // einzeln umgebrochen.
    var hoeheNachher = el.getBoundingClientRect().height;
    if (hoeheNachher > hoeheVorher + 2 || el.scrollWidth > el.clientWidth + 2) { loesen(el); return; }

    // Und zuletzt: ist das gebundene Paar selbst zerrissen worden?
    if (paarRechtecke(el) > 1) loesen(el);
  }

  function durchgang() {
    var kopfzeilen = document.querySelectorAll(SEL);
    for (var i = 0; i < kopfzeilen.length; i++) pruefe(kopfzeilen[i]);
  }

  function start() {
    durchgang();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(durchgang, 60); });
    window.addEventListener('load', function () { setTimeout(durchgang, 400); });
    setTimeout(durchgang, 900);

    // Ueberschriften weiter unten sind beim ersten Durchgang oft noch nicht
    // fertig gesetzt: Bilder ueber ihnen laden nach und verschieben den
    // Umbruch. Deshalb wird jede Ueberschrift zusaetzlich geprueft, sobald
    // sie ins Bild kommt — dann steht ihr Umbruch endgueltig.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (eintraege[i].isIntersecting) pruefe(eintraege[i].target);
        }
      }, { rootMargin: '200px 0px 200px 0px', threshold: 0 });
      var alle = document.querySelectorAll(SEL);
      for (var k = 0; k < alle.length; k++) io.observe(alle[k]);
    }

    var wartet = 0;
    window.addEventListener('resize', function () {
      if (wartet) clearTimeout(wartet);
      wartet = setTimeout(function () { wartet = 0; durchgang(); }, 200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   AUFKLAPPER: IMMER NUR EINER OFFEN
   ------------------------------------------------------------
   Bisher blieben alle geoeffneten Fragen offen. Bei fuenf Fragen
   entstand daraus eine Textwand, und wer die dritte Antwort las,
   hatte die Ueberschrift der Liste laengst aus dem Bild gescrollt.

   Jetzt schliesst das Oeffnen einer Frage die anderen derselben
   Gruppe. Gruppe ist die Sektion, in der die Frage steht: die
   Aufklapp-Liste, die Kaufbox und die FAQ-Seite zaehlen jeweils fuer
   sich. Verschachtelte Aufklapper bleiben unberuehrt.

   Der toggle-Ereignis steigt NICHT auf (kein Bubbling), deshalb
   haengt der Zuhoerer in der Capture-Phase am Dokument. Ein Zuhoerer
   je details-Element waere sonst noetig, und die kommen bei Shopify
   auch nach dem Laden noch dazu.
   ============================================================ */
(function () {
  var GRUPPEN = '.collapsible-content, .product__info-container, .product__accordion-group, main, body';

  document.addEventListener(
    'toggle',
    function (e) {
      var offen = e.target;
      if (!offen || offen.tagName !== 'DETAILS' || !offen.open) return;
      // Nur Aufklapper mit Fragen, nicht die Schubladen des Themes
      // (Menue, Suche, Sortierung) — die tragen eigene Klassen.
      if (offen.closest('.menu-drawer, .header, .facets, .search-modal')) return;

      var gruppe = offen.closest(GRUPPEN);
      if (!gruppe) return;

      var alle = gruppe.querySelectorAll('details[open]');
      for (var i = 0; i < alle.length; i++) {
        var d = alle[i];
        if (d === offen) continue;
        if (d.contains(offen) || offen.contains(d)) continue;
        if (d.closest('.menu-drawer, .header, .facets, .search-modal')) continue;
        d.open = false;
      }
    },
    true
  );
})();

/* ============================================================
   VIDEO: NICHT AUF DER HUEFTE ANFANGEN
   ------------------------------------------------------------
   Der Clip in "Bild mit Text" beginnt auf Guerteltiefe: Hose, Guertel,
   kein Produkt. Genau dieses Bild steht so lange im Rahmen, bis der
   Browser mit dem Abspielen beginnt, und bei gedrosselter Datenrate,
   im Stromsparmodus oder bei reduzierter Bewegung dauerhaft.

   Deshalb wird nach dem Laden der Metadaten anderthalb Sekunden
   vorgespult. Dort ist der Sling im Bild. Das aendert nichts an der
   Datei und nichts am Abspielen, nur am ersten sichtbaren Einzelbild.

   Wird der Clip einmal getauscht und beginnt dann schon richtig,
   kann dieser Block ersatzlos raus.
   ============================================================ */
(function () {
  var START = 1.5;

  function vorspulen(video) {
    if (video.dataset.nsStart) return;
    video.dataset.nsStart = '1';
    var setzen = function () {
      if (!isFinite(video.duration) || video.duration < START + 0.5) return;
      if (video.currentTime < 0.1) {
        try { video.currentTime = START; } catch (e) { /* manche Browser blocken das vor dem Laden */ }
      }
    };
    if (video.readyState >= 1) setzen();
    else video.addEventListener('loadedmetadata', setzen, { once: true });
  }

  function durchgang() {
    var videos = document.querySelectorAll('internal-video video, .image-with-text__media video');
    for (var i = 0; i < videos.length; i++) vorspulen(videos[i]);
  }

  function start() {
    durchgang();
    if (!('MutationObserver' in window)) return;
    var wartet = 0;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = setTimeout(function () { wartet = 0; durchgang(); }, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   PREISE: GESCHUETZTES LEERZEICHEN VOR DEM EURO
   ------------------------------------------------------------
   Das Waehrungsformat des Shops ist "{{amount_with_comma_separator}}€",
   also ohne Leerzeichen. Aendern laesst es sich nur in der
   Admin-Oberflaeche (Einstellungen -> Waehrungsformat), und JEDE
   money-Ausgabe des Themes haengt daran: Preiszeile, Bundle-Karten,
   Sticky-Leiste, Warenkorb, Rabattnamen. Die eigenen Texte schreiben
   "49,98 €", das Theme "49,98€" — in derselben Zeile nebeneinander.

   Dieses Netz setzt das geschuetzte Leerzeichen im fertigen Text nach.
   Es fasst nur Textknoten an, veraendert keine Struktur und laeuft ueber
   einen entprellten MutationObserver mit, weil Shrine Preise nach
   Varianten- und Mengenwechsel neu zeichnet.

   Kein Ersatz fuer das Waehrungsformat im Adminbereich, sondern die
   Abdeckung, solange dort "49,98€" steht.
   ============================================================ */
(function () {
  var NBSP = ' ';
  // Ziffer, optionales normales Leerzeichen, Euro. Bereits gesetztes
  // geschuetztes Leerzeichen bleibt unberuehrt (kein zweiter Durchlauf).
  var RE = /(\d)[ \t]?€/g;

  function fixe(wurzel) {
    if (!wurzel || !wurzel.querySelectorAll) return;
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeValue.indexOf('€') < 0) return NodeFilter.FILTER_REJECT;
        var el = n.parentElement;
        if (!el) return NodeFilter.FILTER_REJECT;
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var knoten = [];
    var n;
    while ((n = lauf.nextNode())) knoten.push(n);
    for (var i = 0; i < knoten.length; i++) {
      var neu = knoten[i].nodeValue.replace(RE, '$1' + NBSP + '€');
      if (neu !== knoten[i].nodeValue) knoten[i].nodeValue = neu;
    }
  }

  function start() {
    fixe(document.body);
    if (!('MutationObserver' in window)) return;
    var wartet = 0;
    var beobachter = new MutationObserver(function () {
      if (wartet) return;
      wartet = setTimeout(function () {
        wartet = 0;
        // Waehrend des eigenen Schreibens nicht auf sich selbst reagieren.
        beobachter.disconnect();
        fixe(document.body);
        beobachter.observe(document.body, { childList: true, subtree: true, characterData: true });
      }, 120);
    });
    beobachter.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   SICHERHEITSNETZ FUER EINBLENDUNGEN
   ------------------------------------------------------------
   Gemessen am 2026-07-29 auf der Live-Produktseite:
     ns-anatomie   opacity 0, translateY(16px)   .ns-in fehlte
     ns-material   opacity 0, translateY(24px)   .ns-in fehlte
     ns-kern       opacity 1, transform none     .ns-in gesetzt
   Zwei komplette Sektionen waren damit fuer Besucher unsichtbar. Kein
   JS-Fehler auf der Seite — der sektionseigene IntersectionObserver hat
   schlicht nie ausgeloest.

   Die Ursache kann je nach Geraet, Scrollposition und Ladereihenfolge
   verschieden sein. Eine Einblendung, die im Fehlerfall Inhalt VERSTECKT,
   darf es aber gar nicht erst geben. Deshalb hier ein Netz, das unabhaengig
   von der Ursache greift: was im oder nahe am Sichtfeld liegt und noch
   nicht eingeblendet ist, wird eingeblendet.
   ============================================================ */
(function () {
  function netz() {
    var kinder = document.querySelectorAll('[data-ns-stagger]');
    for (var i = 0; i < kinder.length; i++) {
      var wurzel = kinder[i].closest('[id^="ns-"]');
      if (!wurzel || wurzel.classList.contains('ns-in')) continue;
      var r = wurzel.getBoundingClientRect();
      // Grosszuegig: alles, was das Sichtfeld schon beruehrt hat oder gleich
      // beruehrt, gilt als gesehen.
      if (r.top < (window.innerHeight || 800) * 1.25) wurzel.classList.add('ns-in');
    }
  }

  // Einmal kurz nach dem Laden, danach beim Scrollen und bei Groessenaenderung.
  if (document.readyState === 'complete') setTimeout(netz, 700);
  else window.addEventListener('load', function () { setTimeout(netz, 700); });

  var wartet = 0;
  function angestossen() {
    if (wartet) return;
    wartet = requestAnimationFrame(function () { wartet = 0; netz(); });
  }
  window.addEventListener('scroll', angestossen, { passive: true });
  window.addEventListener('resize', angestossen);

  // Letzte Reissleine: nach 4 s ist jede Sektion sichtbar, egal wo sie steht.
  setTimeout(function () {
    var kinder = document.querySelectorAll('[data-ns-stagger]');
    for (var i = 0; i < kinder.length; i++) {
      var wurzel = kinder[i].closest('[id^="ns-"]');
      if (wurzel && !wurzel.classList.contains('ns-in') && wurzel.getBoundingClientRect().top < 0) {
        wurzel.classList.add('ns-in');
      }
    }
  }, 4000);
})();

/* ============================================================
   TRENNSTELLEN FUER BANDWURMWOERTER IN DEN RECHTSTEXTEN
   ------------------------------------------------------------
   Gemessen am 29.08.2026 bei 320px im Impressum:
   "…an Streitbeilegungsverfahren vor einer
   Verbraucherschlichtungsstelle teilzunehmen."
   Das vorletzte Wort ist 29 Zeichen lang. Zusammen mit
   "teilzunehmen." braucht das Paar rund 335px, die Spalte ist
   288px breit. Es gibt keinen Umbruch, bei dem nicht ein Wort
   allein auf der letzten Zeile steht.

   Die uebliche Antwort waere `hyphens: auto`. Die steht auch im
   Stylesheet — sie wirkt hier aber nicht: nachgemessen mit Edge
   auf diesem Rechner, mit und ohne Fenster, bleibt ein
   29-Zeichen-Wort in einem 90px-Kasten ungetrennt. Chrome und
   Edge laden die Trennwoerterbucher als eigene Komponente nach,
   und ohne sie ist die Eigenschaft wirkungslos.

   Deshalb die Trennstellen von Hand: eine kurze, gepflegte Liste
   statt einer Regel, die raten muss. Eingefuegt wird ein WEICHER
   Trennstrich (U+00AD) — unsichtbar, bis der Browser dort
   umbricht, und beim Kopieren nicht mit dabei. Am Inhalt aendert
   sich nichts.

   Wer ein Wort ergaenzt: an den Fugen trennen, nicht nach Gefuehl.
   Waechter ist scripts/pruef-umbruch.mjs.
   ============================================================ */
(function () {
  var SHY = '\u00AD';
  var WOERTER = {
    'Verbraucherschlichtungsstelle': 'Verbraucher|schlichtungs|stelle',
    'Verbraucherstreitbeilegungsgesetz': 'Verbraucher|streit|beilegungs|gesetz',
    'Streitbeilegungsverfahren': 'Streit|beilegungs|verfahren',
    'Umsatzsteueridentifikationsnummer': 'Umsatzsteuer|identifikations|nummer',
    'Widerrufsbelehrung': 'Widerrufs|belehrung',
    'Verbraucherschlichtungsstellen': 'Verbraucher|schlichtungs|stellen',
    'Datenschutzerklaerung': 'Datenschutz|erklaerung',
    'Datenschutzerklärung': 'Datenschutz|erklärung',
    'Einwilligungserklaerung': 'Einwilligungs|erklaerung',
    'Einwilligungserklärung': 'Einwilligungs|erklärung',
    'Auftragsverarbeitungsvertrag': 'Auftrags|verarbeitungs|vertrag',
    'Verantwortlichkeitsbereich': 'Verantwortlichkeits|bereich',
    'Gewaehrleistungsanspruechen': 'Gewaehrleistungs|anspruechen',
    'Gewährleistungsansprüchen': 'Gewährleistungs|ansprüchen',
  };

  function trennen(wurzel) {
    if (!wurzel) return;
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var knoten = [];
    var n;
    while ((n = lauf.nextNode())) knoten.push(n);

    for (var i = 0; i < knoten.length; i++) {
      var t = knoten[i].nodeValue;
      if (!t || t.indexOf(SHY) >= 0) continue;
      var neu = t;
      for (var wort in WOERTER) {
        if (neu.indexOf(wort) < 0) continue;
        neu = neu.split(wort).join(WOERTER[wort].split('|').join(SHY));
      }
      if (neu !== t) knoten[i].nodeValue = neu;
    }
  }

  function start() {
    trennen(document.querySelector('.shopify-policy__body'));
    trennen(document.querySelector('.ns-rechtstext'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
